// src/hooks/useInfiniteScroll.ts
"use client";

import { useEffect, useRef } from "react";

type Options = {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
};

export function useInfiniteScroll({ hasMore, isLoading, onLoadMore }: Options) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoading && hasMore) {
          onLoadMore();
        }
      },
      { rootMargin: "200px", threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, isLoading, onLoadMore]);

  return { sentinelRef };
}